// extracted by mini-css-extract-plugin
export default {"list":"AlgorithmList_list__mxIR+","list-heading":"AlgorithmList_list-heading__otPpg","list-items":"AlgorithmList_list-items__ANLdg","item":"AlgorithmList_item__1Fvru"};